import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function ExpandableCard({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}) {
  return <AnimatePresence data-id="element-45">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-[#0B1623]/95 p-4 backdrop-blur-md" data-id="element-46">
          <motion.div initial={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-[#0B1623] border border-white/10 w-full max-w-md rounded-2xl overflow-hidden shadow-2xl flex flex-col max-h-[90vh]" data-id="element-47">
            <div className="flex items-center justify-between p-5 border-b border-white/10" data-id="element-48">
              <h3 className="font-semibold text-white pr-4" data-id="element-49">{title}</h3>
              <button onClick={onClose} className="p-2 text-slate-500 hover:text-white hover:bg-white/10 rounded-full transition-colors flex-shrink-0" aria-label="Close" data-id="element-50">
                <XIcon className="w-5 h-5" data-id="element-51" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto bg-transparent flex-1" data-id="element-52">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}